module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMlJREFUKBWV0bEKwjAQBuC71Lqbp3BQxNlBBN3cnH0wBx/BzVEoDs4i+BwVHKvpmd9QtbVJNZB0+e/LpUfUsAb7yxC7IUYcCgC432iHTCum6WncOfryXuiNiHbFnIawWqiMcOYgaRP5sS+oinAkC0BieGNPL1aC6pDzRG8B9ZJ0HsJeUAgBhBXCntAviKP8GPeTazc35mDfb6fDGf5J8ZyiuPqtdqaiaKRE8uU/CFBc5IaAiYqGoTimNStaKaZZUyefnSGLGtTCeABfgZEjkv9vPgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cronus/path.png
// module id = f352
// module chunks = 0